import React from 'react';

const TYPES = {
  blue: 'primary',
  green: 'green',
  red: 'red',
};

export type BadgeProps = {
  label: string;
  children?: React.ReactNode;
  disabled?: boolean;
  isSelected?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
  [key: string]: any;
};

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  (
    { type = TYPES.blue, disabled, children, label, onClick, className, ...props }: BadgeProps,
    ref,
  ) => {
    const buttonBaseClass = ` ${className} font-bold text-[12px] leading-[12px] rounded-[3px] flex justify-evenly items-center cursor-pointer px-[4px] pt-[2px] pb-[3px]`;

    const buttonBlueClass = `${disabled ? '' : 'bg-blue-100 text-blue-600'}`;
    const buttonGreenClass = `${disabled ? '' : 'bg-green-400 text-green-800'}`;
    const buttonRedClass = `${disabled ? '' : 'bg-red-400 text-red-800'}`;

    const buttonClasses = {
      [TYPES.blue]: `${buttonBaseClass} ${buttonBlueClass} `,
      [TYPES.green]: `${buttonBaseClass} ${buttonGreenClass} `,
      [TYPES.red]: `${buttonBaseClass} ${buttonRedClass}`,
    };

    return (
      <div
        ref={ref}
        onClick={onClick}
        aria-label={label}
        className={buttonClasses[type]}
        {...props}
      >
        {children}
      </div>
    );
  },
);
